import { ref } from "vue";
import {
    Resource,
    ResourceState,
    resourceStatePrototype,
    useResourceState,
} from "@/domains/app/resource";
import { useUser } from "@/domains/auth/user";

export type Location = Resource & {
    label: string;
    user_id: number;
};

export type LocationState = ResourceState<Location>;

/**
 * Create a location state to get data and its mutators
 * @param id Id of the location that the state should be related to
 * @returns a location state with the data and mutators
 */
export function useLocation(id?: number): LocationState {
    const state: LocationState = {
        data: ref(null),
        apiRoute: "locations",
        apiErrors: ref(null),
        save: () => resourceStatePrototype.save(state),
        del: () => resourceStatePrototype.del(state),
        init: () =>
            resourceStatePrototype.init(id, state, {
                id: -1,
                label: "",
                user_id: useUser().user.value?.id || -1,
            }),
    };

    return useResourceState(state);
}
